import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "./contexts/LanguageContext";
import { Toaster } from "./components/ui/sonner";

// Components - Minimal Structure
import Navigation from "./components/Navigation";
import HeroMinimal from "./components/HeroMinimal";
import SolutionMinimal from "./components/SolutionMinimal";
import TechStackSection from "./components/TechStackSection";
import CrewSection from "./components/CrewSection";
import ContactForm from "./components/ContactForm";
import Footer from "./components/Footer";
import WhatsAppButton from "./components/WhatsAppButton";

const HomePage = () => {
  return (
    <div className="min-h-screen bg-slate-950">
      <Navigation />
      <main>
        <HeroMinimal />
        <SolutionMinimal />
        <TechStackSection />
        <CrewSection />
        <ContactForm />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
};

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" />
    </LanguageProvider>
  );
}

export default App;
